var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("v-form", { ref: "saatavariviTable" }, [
        _c("table", { staticClass: "riviTable" }, [
          _c("thead", [
            _c(
              "tr",
              [
                _c(
                  "th",
                  {
                    class: _vm.thClassArr.concat(["riviTable__cell--required"]),
                    attrs: { scope: "col" },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("common:invoiceNo")) + " ")]
                ),
                _c(
                  "th",
                  {
                    class: _vm.thClassArr.concat(["riviTable__cell--required"]),
                    attrs: { scope: "col" },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("common:invoiceDate")) + " ")]
                ),
                _c(
                  "th",
                  {
                    class: _vm.thClassArr.concat(["riviTable__cell--required"]),
                    attrs: { scope: "col" },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("common:dueDate")) + " ")]
                ),
                _vm.toimeksianto.muistutettu
                  ? [
                      _c(
                        "th",
                        {
                          class: _vm.thClassArr.concat([
                            "riviTable__cell--required",
                          ]),
                          attrs: { scope: "col" },
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("common:reminderDate")) + " "
                          ),
                        ]
                      ),
                      _c(
                        "th",
                        {
                          class: _vm.thClassArr.concat([
                            "riviTable__cell--required",
                          ]),
                          attrs: { scope: "col" },
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("common:reminderDueDate")) + " "
                          ),
                        ]
                      ),
                      _c(
                        "th",
                        {
                          class: _vm.thClassArr.concat([
                            "riviTable__cell--required",
                          ]),
                          attrs: { scope: "col" },
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("common:reminderFee")) + " "
                          ),
                        ]
                      ),
                    ]
                  : _vm._e(),
                _c(
                  "th",
                  {
                    class: _vm.thClassArr.concat(["riviTable__cell--required"]),
                    attrs: { scope: "col" },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("common:invoiceRef")) + " ")]
                ),
                _c(
                  "th",
                  {
                    class: _vm.thClassArr.concat(
                      ["riviTable__cell--required"],
                      ["text-right"]
                    ),
                    attrs: { scope: "col" },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("common:capital")) + " ")]
                ),
                _c("th", { class: _vm.thClassArr, attrs: { scope: "col" } }, [
                  _vm._v(" " + _vm._s(_vm.$t("common:definition")) + " "),
                ]),
                _c("th", { class: _vm.thClassArr, attrs: { scope: "col" } }, [
                  _vm._v(" " + _vm._s(_vm.$t("common:lateInterest")) + " "),
                ]),
              ],
              2
            ),
          ]),
          _c(
            "tbody",
            _vm._l(_vm.toimeksianto.rivit, function (item, index) {
              return _c(
                "tr",
                {
                  key: item.index,
                  attrs: { disabled: true },
                  on: { input: _vm.lahetaEventKayttajasyote },
                },
                [
                  _c(
                    "td",
                    {
                      class: _vm.tdClassArr.concat([
                        "riviTable__cell--min-width-medium",
                      ]),
                    },
                    [
                      _c("v-text-field", {
                        attrs: {
                          type: "text",
                          "hide-details": "",
                          rules: [_vm.$validationRules.required],
                        },
                        on: {
                          keydown: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.toimeksianto.lisaaRivi(index)
                          },
                        },
                        model: {
                          value: item.laskunumero,
                          callback: function ($$v) {
                            _vm.$set(item, "laskunumero", $$v)
                          },
                          expression: "item.laskunumero",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "td",
                    { class: _vm.tdClassArr },
                    [
                      _c("v-menu", {
                        attrs: {
                          "close-on-content-click": false,
                          "max-width": "290",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function (ref) {
                                var on = ref.on
                                return [
                                  _c(
                                    "v-text-field",
                                    _vm._g(
                                      {
                                        attrs: {
                                          value: _vm.$date(item.laskupaiva),
                                          readonly: "",
                                          "hide-details": "",
                                          rules: [
                                            _vm.$validationRules.required,
                                          ],
                                        },
                                      },
                                      on
                                    )
                                  ),
                                ]
                              },
                            },
                            {
                              key: "default",
                              fn: function () {
                                return [
                                  _c("v-date-picker", {
                                    attrs: {
                                      locale: _vm.$languageLocale(),
                                      "first-day-of-week": "1",
                                      "no-title": "",
                                    },
                                    on: {
                                      change: function ($event) {
                                        _vm.laskupaivaMenu = false
                                      },
                                    },
                                    model: {
                                      value: item.laskupaiva,
                                      callback: function ($$v) {
                                        _vm.$set(item, "laskupaiva", $$v)
                                      },
                                      expression: "item.laskupaiva",
                                    },
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          true
                        ),
                        model: {
                          value: _vm.laskupaivaMenu,
                          callback: function ($$v) {
                            _vm.laskupaivaMenu = $$v
                          },
                          expression: "laskupaivaMenu",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "td",
                    { class: _vm.tdClassArr },
                    [
                      _c("v-menu", {
                        attrs: {
                          "close-on-content-click": false,
                          "max-width": "290",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function (ref) {
                                var on = ref.on
                                return [
                                  _c(
                                    "v-text-field",
                                    _vm._g(
                                      {
                                        attrs: {
                                          value: _vm.$date(item.erapaiva),
                                          readonly: "",
                                          "hide-details": "",
                                          rules: [
                                            _vm.$validationRules.required,
                                          ],
                                        },
                                      },
                                      on
                                    )
                                  ),
                                ]
                              },
                            },
                            {
                              key: "default",
                              fn: function () {
                                return [
                                  _c("v-date-picker", {
                                    attrs: {
                                      locale: _vm.$languageLocale(),
                                      "first-day-of-week": "1",
                                      "no-title": "",
                                    },
                                    on: {
                                      change: function ($event) {
                                        _vm.erapaivaMenu = false
                                      },
                                    },
                                    model: {
                                      value: item.erapaiva,
                                      callback: function ($$v) {
                                        _vm.$set(item, "erapaiva", $$v)
                                      },
                                      expression: "item.erapaiva",
                                    },
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          true
                        ),
                        model: {
                          value: _vm.erapaivaMenu,
                          callback: function ($$v) {
                            _vm.erapaivaMenu = $$v
                          },
                          expression: "erapaivaMenu",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.toimeksianto.muistutettu
                    ? [
                        _c(
                          "td",
                          { class: _vm.tdClassArr },
                          [
                            _c("v-menu", {
                              attrs: {
                                "close-on-content-click": false,
                                "max-width": "290",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function (ref) {
                                      var on = ref.on
                                      return [
                                        _c(
                                          "v-text-field",
                                          _vm._g(
                                            {
                                              attrs: {
                                                value: _vm.$date(
                                                  item.muistutuspaiva
                                                ),
                                                readonly: "",
                                                "hide-details": "",
                                                rules: _vm.toimeksianto
                                                  .muistutettu
                                                  ? [
                                                      _vm.$validationRules
                                                        .required,
                                                    ]
                                                  : [],
                                              },
                                            },
                                            on
                                          )
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "default",
                                    fn: function () {
                                      return [
                                        _c("v-date-picker", {
                                          attrs: {
                                            locale: _vm.$languageLocale(),
                                            "first-day-of-week": "1",
                                            "no-title": "",
                                          },
                                          on: {
                                            change: function ($event) {
                                              _vm.muistutuspaivaMenu = false
                                            },
                                          },
                                          model: {
                                            value: item.muistutuspaiva,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                item,
                                                "muistutuspaiva",
                                                $$v
                                              )
                                            },
                                            expression: "item.muistutuspaiva",
                                          },
                                        }),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                true
                              ),
                              model: {
                                value: _vm.muistutuspaivaMenu,
                                callback: function ($$v) {
                                  _vm.muistutuspaivaMenu = $$v
                                },
                                expression: "muistutuspaivaMenu",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "td",
                          { class: _vm.tdClassArr },
                          [
                            _c("v-menu", {
                              attrs: {
                                "close-on-content-click": false,
                                "max-width": "290",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function (ref) {
                                      var on = ref.on
                                      return [
                                        _c(
                                          "v-text-field",
                                          _vm._g(
                                            {
                                              attrs: {
                                                value: _vm.$date(
                                                  item.muistutuserapaiva
                                                ),
                                                readonly: "",
                                                "hide-details": "",
                                                rules: _vm.toimeksianto
                                                  .muistutettu
                                                  ? [
                                                      _vm.$validationRules
                                                        .required,
                                                    ]
                                                  : [],
                                              },
                                            },
                                            on
                                          )
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "default",
                                    fn: function () {
                                      return [
                                        _c("v-date-picker", {
                                          attrs: {
                                            locale: _vm.$languageLocale(),
                                            "first-day-of-week": "1",
                                            "no-title": "",
                                          },
                                          on: {
                                            change: function ($event) {
                                              _vm.muistutuserapaivaMenu = false
                                            },
                                          },
                                          model: {
                                            value: item.muistutuserapaiva,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                item,
                                                "muistutuserapaiva",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "item.muistutuserapaiva",
                                          },
                                        }),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                true
                              ),
                              model: {
                                value: _vm.muistutuserapaivaMenu,
                                callback: function ($$v) {
                                  _vm.muistutuserapaivaMenu = $$v
                                },
                                expression: "muistutuserapaivaMenu",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "td",
                          { class: _vm.tdClassArr },
                          [
                            _c("v-text-field", {
                              attrs: {
                                type: "number",
                                rules: _vm.toimeksianto.muistutett
                                  ? [_vm.$validationRules.required]
                                  : [],
                                required: "",
                                reverse: "",
                                "hide-details": "",
                              },
                              on: {
                                keydown: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.toimeksianto.lisaaRivi(index)
                                },
                              },
                              model: {
                                value: item.muistutuskulu,
                                callback: function ($$v) {
                                  _vm.$set(item, "muistutuskulu", $$v)
                                },
                                expression: "item.muistutuskulu",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                  _c(
                    "td",
                    { class: _vm.tdClassArr },
                    [
                      _c("v-text-field", {
                        attrs: {
                          type: "text",
                          reverse: "",
                          "hide-details": "",
                        },
                        on: {
                          keydown: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.toimeksianto.lisaaRivi(index)
                          },
                        },
                        model: {
                          value: item.pm_viite,
                          callback: function ($$v) {
                            _vm.$set(item, "pm_viite", $$v)
                          },
                          expression: "item.pm_viite",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "td",
                    { class: _vm.tdClassArr },
                    [
                      _c("v-text-field", {
                        attrs: {
                          type: "number",
                          rules: [_vm.$validationRules.required],
                          required: "",
                          reverse: "",
                          "hide-details": "",
                        },
                        on: {
                          keydown: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.toimeksianto.lisaaRivi(index)
                          },
                        },
                        model: {
                          value: item.paaoma,
                          callback: function ($$v) {
                            _vm.$set(item, "paaoma", $$v)
                          },
                          expression: "item.paaoma",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "td",
                    { class: _vm.tdClassArr },
                    [
                      _c("v-text-field", {
                        attrs: {
                          type: "text",
                          reverse: "",
                          "hide-details": "",
                        },
                        on: {
                          keydown: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.toimeksianto.lisaaRivi(index)
                          },
                        },
                        model: {
                          value: item.selite,
                          callback: function ($$v) {
                            _vm.$set(item, "selite", $$v)
                          },
                          expression: "item.selite",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "td",
                    { class: _vm.tdClassArr },
                    [
                      _c("v-text-field", {
                        attrs: {
                          type: "number",
                          rules: [_vm.tarkistaViivkorko],
                          hint: _vm.viivkorkoInfo,
                          suffix: "%",
                        },
                        on: {
                          keydown: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.toimeksianto.lisaaRivi(index)
                          },
                        },
                        model: {
                          value: item.viivastyskorko,
                          callback: function ($$v) {
                            _vm.$set(item, "viivastyskorko", $$v)
                          },
                          expression: "item.viivastyskorko",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "td",
                    { staticClass: "riviTable__cell--btn" },
                    [
                      _vm.salliPoistaminen
                        ? _c("LomakenappiIkonilla", {
                            attrs: {
                              ikoni: "delete",
                              infoteksti: _vm.$t("deleteRow"),
                              "nayta-aina": "",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.poistaRivi(index)
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                2
              )
            }),
            0
          ),
          _vm.naytaYhteenveto
            ? _c("tfoot", { staticClass: "riviTable__footer" }, [
                _c("div", { staticClass: "mt-5" }),
                _c("tr", [
                  _c(
                    "td",
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.toimeksianto.lisaaRivi()
                            },
                          },
                        },
                        [
                          _c("v-icon", { attrs: { left: "", icon: "" } }, [
                            _vm._v(" library_add "),
                          ]),
                          _vm._v(" " + _vm._s(_vm.$t("common:newRow")) + " "),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "th",
                    {
                      staticClass: "riviTable__cell riviTable__cell--footer",
                      attrs: { colspan: "3", scope: "row" },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("common:total")) + " ")]
                  ),
                  _c(
                    "td",
                    { staticClass: "riviTable__cell riviTable__cell--footer" },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm._f("formatSumToFixed2")(_vm.paaomaYhteensa)
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c("td", {
                    staticClass: "riviTable__cell riviTable__cell--footer",
                  }),
                  _c("td", {
                    staticClass: "riviTable__cell riviTable__cell--footer",
                  }),
                ]),
              ])
            : _vm._e(),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }